const linkParser = (link: string) => {
  const a = document.createElement('a');
  a.href = /(http(s?)):\/\//i.test(link) ? link : `//${link}`;
  return a.href;
};

export default linkParser;
